import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CustomInput
} from 'reactstrap';
import { Colxx } from '../../../../../../../components/common/CustomBootstrap';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import { gAPI_TemplateAddOnList } from '../../../../../../../constants/APIs';
import AddOnThumbListView from './AddOnThumbListView';

export function TemplateAddOnList({
    visible,
    toggle,
    formLabel,
    submit,
    updatePormosData,
    propertyId
}) {

    const [addonsData, setaddonsData] = useState([]);
    const [selectedItems, setselectedItems] = useState([]);
    const [lastChecked, setlastChecked] = useState(null);
    useEffect(() => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_TemplateAddOnList}?languageCode=en`,
        })
            .then(res => {
                setaddonsData(res.data);
            })
            .catch(err => console.log('err', err));
    }, [propertyId]);

    const handleSubmit = () => {
        var data = {
            propertyId: propertyId,
            addons: selectedItems
        }
        submit(data);
    };

    const onCheckItem = (event, id) => {
        if (
            event.target.tagName === "A" ||
            (event.target.parentElement && event.target.parentElement.tagName === "A")
        ) {
            return true;
        }
        if (lastChecked === null) {
            setlastChecked({ lastChecked: id })
        }

        let selitems = selectedItems;
        if (selitems.includes(id)) {
            selitems = selitems.filter(x => x !== id);
        } else {
            selitems.push(id);
        }
        setselectedItems([...selitems])
        document.activeElement.blur();
    };

    const handleChangeSelectAll = isToggle => {
        if (selectedItems.length >= addonsData.length) {
            if (isToggle) {
                setselectedItems([])
            }
        } else {
            let selitems = []
            addonsData.map(x => selitems.push(x.id))
            setselectedItems([...selitems])
        }
        document.activeElement.blur();
        return false;
    };

    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
                <ModalBody>
                    <Row>
                        <Colxx xxs="12">
                            <div className="mb-2">
                                <div className="text-zero">
                                    <div className="pr-0 check-button check-all">
                                        <CustomInput
                                            className="custom-checkbox mb-0 d-inline-block"
                                            type="checkbox"
                                            id="checkAll"
                                            checked={selectedItems.length >= addonsData.length}
                                            onChange={() => handleChangeSelectAll(true)}
                                            label="Select All"
                                        />
                                    </div> </div> </div> </Colxx></Row>

                    <Row>
                        {addonsData !== undefined && addonsData.map(addon => {
                            return (
                                <AddOnThumbListView
                                    key={addon.id}
                                    addon={addon}
                                    isSelect={selectedItems.includes(addon.id)}
                                    onCheckItem={onCheckItem}
                                />
                            );
                        }
                        )}
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <p> These will be added with draft status, you can edit and make them active when you ready </p>
                    <Button color="primary" onClick={handleSubmit}>
                        Add Selected
          </Button>
                    <Button color="secondary" onClick={toggle}>
                        Cancel
          </Button>
                </ModalFooter>
            </Modal>
        </Fragment>)
};